/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["fx-button-edit .ant-input-affix-wrapper .ant-input:not(:first-child){padding-left:11px}fx-button-edit .has-error .ant-form-explain{display:block!important}fx-button-edit .ant-form-item-control .ant-form-explain{display:none}.mat-option{line-height:normal!important;height:auto!important;min-height:32px;white-space:normal!important;padding:3px 16px!important}.mat-option.active{background-color:#d9d9d9}.mat-autocomplete-panel.mat-autocomplete-visible{background-color:#fff!important}"];
export { styles as styles };
